import { render, staticRenderFns } from "./questionRes.vue?vue&type=template&id=34c31807&scoped=true&"
import script from "./questionRes.vue?vue&type=script&lang=js&"
export * from "./questionRes.vue?vue&type=script&lang=js&"
import style0 from "./questionRes.vue?vue&type=style&index=0&id=34c31807&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34c31807",
  null
  
)

export default component.exports